const selectors = {
  removeButton: '[data-vehicle-comparison-card-remove-button]',
};

export { selectors };
